import { format } from 'date-fns'
import React from 'react'

interface ThermalReceiptProps {
  order: any
  company: any
  customer: any
  vehicle: any
  preview?: boolean
}

// O componente usa uma ref (encaminhada) para o react-to-print.
// Estilo otimizado para bobinas térmicas (58mm/80mm).
export const ThermalReceipt = React.forwardRef<HTMLDivElement, ThermalReceiptProps>(
  ({ order, company, customer, vehicle, preview = false }, ref) => {
    if (!order) return null

    const services = (order.services as any[]) || []

    return (
      <div
        className={
          preview
            ? 'w-full overflow-hidden rounded-xl border shadow-sm pointer-events-none'
            : 'hidden'
        }
      >
        {/* A div principal fica escondida na UI normal, mas será impressa pelo react-to-print */}
        <div
          ref={ref}
          className="p-4 text-black bg-white"
          style={{
            width: preview ? '100%' : '80mm',
            maxWidth: '300px',
            margin: '0 auto',
            fontFamily: 'monospace',
            fontSize: '12px',
          }}
        >
          {/* Cabeçalho Empresa */}
          <div className="text-center mb-4">
            <h1 className="font-bold text-lg mb-1">{company?.name || 'LAVA-JATO'}</h1>
            {company?.cnpj && <div className="text-[10px]">CNPJ: {company.cnpj}</div>}
            {company?.phone && <div className="text-[10px]">Tel: {company.phone}</div>}
            {company?.address && (
              <div className="text-[10px] whitespace-pre-wrap mt-1">{company.address}</div>
            )}
          </div>

          <div className="border-b border-dashed border-black my-3"></div>

          {/* Dados OS */}
          <div className="mb-3 text-[11px]">
            <div className="font-bold text-center mb-2">
              ORDEM DE SERVIÇO #
              {order.os_number
                ? String(order.os_number).padStart(3, '0')
                : order.id?.substring(0, 8).toUpperCase()}
            </div>
            <div>
              <span className="font-bold">Data:</span>{' '}
              {format(new Date(order.created_at || new Date()), 'dd/MM/yyyy HH:mm')}
            </div>
            {customer && (
              <div>
                <span className="font-bold">Cliente:</span> {customer.name}
              </div>
            )}
            {vehicle && (
              <div>
                <span className="font-bold">Veículo:</span> {vehicle.model} - {vehicle.plate}
              </div>
            )}
          </div>

          <div className="border-b border-dashed border-black my-3"></div>

          {/* Serviços */}
          <div className="mb-3">
            <div className="font-bold mb-2 text-center text-[11px]">SERVIÇOS EXECUTADOS</div>
            <table className="w-full text-[11px]">
              <thead>
                <tr className="border-b border-black">
                  <th className="text-left font-bold pb-1">Item</th>
                  <th className="text-right font-bold pb-1">Valor</th>
                </tr>
              </thead>
              <tbody>
                {services.map((svc: any, idx: number) => (
                  <tr key={idx}>
                    <td className="py-1">{svc.name}</td>
                    <td className="text-right py-1">
                      R$ {Number(svc.price).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="border-b border-dashed border-black my-3"></div>

          {/* Totais */}
          <div className="text-right text-[12px]">
            {Number(order.discount_amount) > 0 && (
              <div className="mb-1">
                Subtotal: R${' '}
                {(Number(order.total) + Number(order.discount_amount)).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}
                <br />
                Desconto: - R${' '}
                {Number(order.discount_amount).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}
              </div>
            )}
            <div className="font-bold text-sm">
              TOTAL: R$ {Number(order.total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </div>
            {order.status === 'PAGO' && (
              <div className="font-bold mt-1 uppercase">SITUAÇÃO: PAGO</div>
            )}
          </div>

          <div className="border-b border-dashed border-black my-3"></div>

          {/* Rodapé / Pix */}
          <div className="text-center text-[10px] mt-4">
            {company?.pix_key && (
              <div className="mb-3">
                <span className="font-bold">CHAVE PIX:</span>
                <br />
                {company.pix_key}
              </div>
            )}
            <div>{company?.receipt_footer || 'Obrigado pela preferência! Volte sempre.'}</div>

            <div className="mt-6 text-[8px] text-gray-500">Gerado por AutoWash Pro SaaS</div>
          </div>
        </div>
      </div>
    )
  }
)

ThermalReceipt.displayName = 'ThermalReceipt'
